import * as actionTypes from '../actions/actionTypes';
import { currentMembersOfCongressGet } from '../actions/actions';

const initialState = {
    voteRecords: [],
    voteRecordsAddendum: [],
    voteRecordsPn1789: [],
    voteRecordsBigBeautifulBill: [],
    voteRecordsBigBeautifulHouse2: [],
    voteRecordsFlexibility: [],
    voteRecordsPrudent: [],
    currentMembersOfCongress: [],
    currentMembersOfCongressDetails: [],
    newMembersOfCongress: [],
    localCongressionalDistricts: [],
    addressSearchResults: null,
    searchResultMembers: [], 
    searchResultNormalizedAddress: null,
    searchResultOfficials: [],
    membersOfCongressDropDownList: [],
    actionErrorMessage: null
};

const reducer = (state= initialState, action) => {

    switch (action.type){
        case actionTypes.GET_CURRENT_MEMBERS_OF_CONGRESS_SUCCESS: {

            //build a memberlist formatted for the dropdown
            const memberList= [];
            action.currentMembersOfCongress.map(member=>{
                if (member.short_title =="Rep")
                {
                    memberList.push({"label" : member.last_name + ", " + member.first_name + " - " + member.short_title + ". " + member.party.charAt(0) + "-" + member.state.toUpperCase() + "-" + member.district, "id" : member.id});
                }
                else
                {
                    memberList.push({"label" : member.last_name + ", " + member.first_name + " - " + member.short_title + ". " + member.party.charAt(0) + "-" + member.state.toUpperCase(), "id": member.id});
                }
            });
            
            return {...state,
                currentMembersOfCongress: action.currentMembersOfCongress, 
                membersOfCongressDropDownList: memberList
            };
        }
        case actionTypes.GET_NEW_MEMBERS_OF_CONGRESS_SUCCESS: {
            return {...state,
                newMembersOfCongress: action.newMembersOfCongress 
            };
        }
        case actionTypes.GET_LOCAL_CONGRESSIONAL_DISTRICTS_SUCCESS: {
            return {...state,
                localCongressionalDistricts: action.localCongressionalDistricts 
            };
        }
        case actionTypes.GET_ADDRESS_SEARCH_RESULTS_SUCCESS: {
            //convert the address search results to an elected officials list
            /*const offices=action.addressSearchResults.offices;
            const officials=action.addressSearchResults.officials;*/
            const address=action.addressSearchResults.normalizedInput;
            const normalizedAddress = address.line1 + ' ' + address.city + ', ' + address.state + ' ' + address.zip;
            const allOfficials = [];
            let i=0;
            /*offices.map(ofc=>{
            ofc.officialIndices.map(idx=>{
                    allOfficials.push({'id': i, 'office': ofc.name, 'name' : officials[idx].name, 'party': officials[idx].party});
                    i+=1;
                })
            })*/
            return {...state,
                addressSearchResults: action.addressSearchResults,
                searchResultMembers: action.searchResultMembers,
                searchResultNormalizedAddress: normalizedAddress,
                searchResultOfficials: allOfficials,
            };
        }
        case actionTypes.GET_DISTRICT_SEARCH_RESULTS_SUCCESS: {
            return {...state,
                searchResultMembers: action.searchResultMembers,
            };
        }
        case actionTypes.GET_VOTE_RECORDS_SUCCESS: {
            return {...state,
                voteRecords: action.voteRecords
            };
        }
        case actionTypes.GET_VOTE_RECORDS_ADDENDUM_SUCCESS: {
            //alert(action.voteRecordsAddendum[0].member_id)
            return {...state,
                voteRecordsAddendum: action.voteRecordsAddendum
            };
        }
        case actionTypes.GET_VOTE_RECORDS_PN1789_SUCCESS: {
            //alert(action.voteRecordsAddendum[0].member_id)
            return {...state,
                voteRecordsPn1789: action.voteRecordsPn1789
            };
        }
        case actionTypes.GET_VOTE_RECORDS_BIG_BEAUTIFUL_BILL_SUCCESS: {
            //alert(action.voteRecordsAddendum[0].member_id)
            return {...state,
                voteRecordsBigBeautifulBill: action.voteRecordsBigBeautifulBill
            };
        }
        case actionTypes.GET_VOTE_RECORDS_BIG_BEAUTIFUL_HOUSE2_SUCCESS: {
            return {...state,
                voteRecordsBigBeautifulHouse2: action.voteRecordsBigBeautifulHouse2
            };
        }
        case actionTypes.GET_VOTE_RECORDS_FLEXIBILITY_SUCCESS: {
            return {...state,
                voteRecordsFlexibility: action.voteRecordsFlexibility
            };
        }
        case actionTypes.GET_VOTE_RECORDS_PRUDENT_SUCCESS: {
            return {...state,
                voteRecordsPrudent: action.voteRecordsPrudent
            };
        }
        case actionTypes.GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS_SUCCESS: {

            let combinedDetails = state.currentMembersOfCongressDetails;
            let filtered;
            if (combinedDetails.length==0)
            {
                combinedDetails = [...combinedDetails, ...action.currentMembersOfCongressDetails];
            }
            else
            {
                action.currentMembersOfCongressDetails.map(dtl=>{
                    //only add id a new record
                    filtered=combinedDetails.filter(combDetails=>combDetails.bioguideId==dtl.bioguideId)[0];
                    if(!filtered){
                        combinedDetails = [...combinedDetails, dtl];
                    }
                })
            }
            return {...state,
                currentMembersOfCongressDetails: combinedDetails
            };
        }
        case actionTypes.CLEAR_SEARCH_RESULTS: {
            //check the currentMembers for the anamoly before each search
            //and do this housekeeping just in case
            let currentMembersVerified = state.currentMembersOfCongress;
            if (currentMembersVerified[0].short_title==0){
                //one record was bad, they all need to be updated
                currentMembersVerified.map(member=>{
                    if (member.isSen=="TRUE"){
                        member.short_title="Sen";
                    }
                    else
                    {
                        member.short_title="Rep";
                    }    
                })
            }

            return {...state,
                currentMembersOfCongress: currentMembersVerified,
                addressSearchResults: null,
                searchResultMembers: [],
                searchResultNormalizedAddress: null,
                searchResultOfficials: [], 
                actionErrorMessage: null
            };
        }
        case actionTypes.ACTION_ERROR: {
            return {...state,
                actionErrorMessage: action.actionErrorMessage
            };
        }
        default: {
           return state;
        }
    }

};

export default reducer;
